import React from 'react';
import {Box, Card, CardContent, CardHeader, IconButton, Typography} from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';


import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import EventIcon from "@mui/icons-material/Event";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";




const StatisticCard = ({title,color,value,isAmount,onClick,icon, padding,height, subTitle}) => {
    return (

// New Design
<Card 
sx={{
  borderRadius: '10px',
  padding: padding ? padding : { lg: "2px 36px", sm: "2px 50px", xs: "2px 46px" },
  height: height ? height :"100%",
  borderTop:`5px solid ${color}` ,
  cursor: onClick ? 'pointer' : '',
  alignItems:"center",
  boxShadow: '0px 10px 15px rgba(0, 0, 0, 0.1)', // Adding a shadow for card
 
}}
onClick={onClick}
> 
<Box  sx={{   display: 'flex',
  flexDirection: 'row', 
  justifyContent: 'space-between',marginTop:"20px" , alignItems:'center'}}>
<Typography style={{fontSize:'1rem', color: '#6B7280',}}> {title}</Typography>
{icon && (
<Box
  sx={{
    display: 'flex', // Center the content horizontally and vertically  
    justifyContent: 'center',     
    alignItems: 'center',
    borderRadius: '50%', // Circular shape 
    backgroundColor: '#19a2ff05', // Light background color
    width: '60px', // Size of the box
    height: '60px', // Size of the box
    boxShadow: '0px 0px 10px rgba(15, 75, 239, 0.15)', // Shadow effect
    '&:hover': {
      boxShadow: '0px 0px 15px rgba(11, 122, 233, 0.2)', // Hover effect 
      backgroundColor: 'rgb(107, 114, 128,)', // Darker background on hover  
    },
  }}
>
  {icon} {/* Icon inside the cir0cle */}
</Box>
)}
</Box>


<Box sx={{}}>

<CardContent sx={{ padding:'0 0 15px 0' }}> 
  <Typography
    sx={{
      fontSize: '30px',
      color: color,
      fontWeight:'bold',
      // textAlign: 'center',
      '@media (min-width:1200px) and (max-width: 1330px)': {
        fontSize: '35px',
      },
    }}
  >
    {isAmount && "$"}{value}
  </Typography>
  <Typography variant="subtitle2"  sx={{ color:"rgb(147, 150, 155)",mt:1 }}>
  {subTitle}
  </Typography>
</CardContent>  
      
</Box>
</Card>

    );
};

export default StatisticCard;